var exports = {
  "kL": "xf0b3b88a--101a30--container",
  "XU": "xf0b3b88a--101a30--container_mobile",
  "qr": "xf0b3b88a--101a30--footer",
  "Aq": "xf0b3b88a--101a30--submit_button",
  "my": "xf0b3b88a--101a30--avatar",
  "Qs": "xf0b3b88a--101a30--content",
  "H7": "xf0b3b88a--101a30--inactive_button",
  "DD": "xf0b3b88a--101a30--title",
  "Zd": "xf0b3b88a--101a30--form",
  "uf": "xf0b3b88a--101a30--stars",
  "w1": "xf0b3b88a--101a30--stars-tooltip",
  "AB": "xf0b3b88a--101a30--stars-container",
  "jP": "xf0b3b88a--101a30--stars-star",
  "nB": "xf0b3b88a--101a30--stars-description",
  "PC": "xf0b3b88a--101a30--textarea",
  "U0": "xf0b3b88a--101a30--submit_button_wrapper",
  "h_": "xf0b3b88a--101a30--description",
};

module.exports = exports;
